const state = {
  selectedInvoiceDataIndex: undefined,
};

export default state;
